<template>
    <div class="catalog-screen">
        <div v-if="Object.keys(data).length > 0" class="row">
            <div v-for="item in data" class="col-sm-6 col-lg-4 catalog-item">
                <div class="premise-page-preview position-relative">
                    <div>
                        <a :href="getUrl(item.alias.url)">
                            <div class="catalog-item-name">
                                <p :title="item.name">{{item.name}}</p>
                            </div>
                            <div class="top-row">
                                <div class="item-image">
                                    <img class="b-lazy img-fluid"
                                         :src="item.image.src"
                                         :alt="item.image.alt">
                                </div>
                                <div class="text-block">
                                    <div class="premise-address">
                                        <p>{{item.address}}</p>
                                    </div>
                                    <div class="premise-text text-section d-none d-sm-block">
                                        <p class="cut-text" v-html="cutText(item.text)"></p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <div class="bottom-row d-flex">
                            <div class="price-block">
                                <p><span>{{ Lang.get('js.my-warehouse.price') }}</span>{{item.price}} {{item.measure}}</p>
                            </div>
                            <div class="area-block">
                                <p><span>{{ Lang.get('js.my-warehouse.square') }}</span>{{item.area}}м2</p>
                            </div>
                        </div>
                      <div class="edit-button">
                        <a :href="`/edit-storehouse/${item.id}`" class="btn my-btn type-1"><i class="fa	far fa-edit"></i>   {{ Lang.get('js.premise.edit') }}</a>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <i v-else-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success" style="font-size: 15px;"></i>
        <p v-else class="text-center m-0 py-4">{{ Lang.get('js.premise.empty') }}</p>
    </div>

</template>

<script>
    import Blazy from 'blazy';

    export default {
        name: 'my-warehouse',
        props: {
            userId: {
                required: true,
            },
        },
        data() {
            return {
                Lang,
                loading: true,
                data: [],
            }
        },
        methods: {
            getPremisePages() {
                let userId = this.userId;
                this.loading = true;
                axios.post('/user/premise', {userId: userId, language: Lang.locale}).then(res => {
                    this.data = res.data;
                    this.loading = false;

                    setTimeout(function () {
                        let bLazy = new Blazy();
                    }, 100);
                }).catch(err => console.log(err));
            },
            getUrl(link) {
                return window.location.origin + '/' + link;
            },
            cutText(text) {
                let limit = 75;

                text = text.trim();
                if (text.length <= limit) {
                    return text;
                }
                text = text.slice(0, limit);

                return text.trim().replace(/<[^>]+>/g, '') + " <span class=\"button-next\">" + Lang.get('js.my-warehouse.more') + "</span>";

            },
        },
        mounted() {
            this.getPremisePages(this.status);
        },
        watch: {},
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/profile/MyWarehouse.vue